<rt-input
  #datePickerDropdownOrigin="rtOverlayOrigin"
  [hasDropdownIndicator]="true"
  [readOnly]="true"
  [value]="inputValue()"
  (click)="toggleDropdown()"
  variant="rounded"
  rt-overlay-origin
>
</rt-input>

<ng-template
  #datePickerDropdown="rtConnectedOverlay"
  [origin]="datePickerDropdownOrigin"
  [open]="dropdownOpen()"
  (backdropClick)="toggleDropdown(false)"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown (click)="$event.stopPropagation()">
    <rt-date-picker
      [formControl]="input().control"
      [blackout]="isDateDisabled()"
      (valueChanged)="toggleDropdown(false)"
    >
    </rt-date-picker>
  </rt-dropdown>
</ng-template>
